/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_Project_As_DescInputs */



/**
* | output |
* | --- |
* | "Save project as" |
*
* @param {Save_Project_As_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_project_as_desc = /** @type {((inputs?: Save_Project_As_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Project_As_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le projet sous")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt speichern unter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva progetto come")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить проект как")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar proyecto como")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将项目另存为")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを名前を付けて保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("के रूप में इस परियोजना को बचाओ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar projeto como")
	return /** @type {LocalizedString} */ ("Save project as")
});